interface BrandWordmarkProps {
  className?: string;
}

export function BrandWordmark({ className }: BrandWordmarkProps) {
  return (
    <span className={className}>
      <span className="font-semibold text-primary">Agent</span>
      <span className="font-light text-secondary">Brush</span>
    </span>
  );
}
